import React, {useState, useEffect} from 'react';
import NoInternetLogo from "./NoInternetLogo";

const NoInternetConnection = (props) => {
    // state variable holds the state of the internet connection
    const [isOnline, setOnline] = useState(true);

    // On initization set the isOnline state.
    useEffect(()=>{
        setOnline(navigator.onLine)
    },[])

    // event listeners to update the state 
    window.addEventListener('online', () => {
        setOnline(true)
    });

    window.addEventListener('offline', () => {
        setOnline(false)
    });

    // if user is online, return the child component else return a custom component
    if(isOnline){
    return(
        props.children
    )
    } else {
        return(  <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
        {/* <h1 className="text-4xl font-bold mb-4">Offline Design</h1> */}
       <NoInternetLogo/>
      </div>)
    }
}

export default NoInternetConnection;